import Modal from "react-modal";
import { FaInfoCircle, FaUpload } from "react-icons/fa";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { closeModal } from "../../redux/slices/modalSlice";
import { handleBulkUploadButtonClick } from "../../tools/utils";
interface Props {
  isOpen: boolean;
  fileInputRef: React.RefObject<HTMLInputElement>;
  onFileUpload: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

export default function BulkUploadInfoModal({
  isOpen,
  fileInputRef,
  onFileUpload,
}: Props) {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={() => dispatch(closeModal("bulkUploadInfoModal"))}
      shouldCloseOnOverlayClick={false}
      contentLabel="Bulk Upload Instructions"
      style={{
        overlay: {
          backgroundColor: "rgba(0, 0, 0, 0.45)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          zIndex: 2000,
        },
        content: {
          inset: "unset",
          width: "90vw",
          maxWidth: "700px",
          maxHeight: "85vh",
          borderRadius: "20px",
          padding: "0",
          border: "none",
          overflow: "hidden",
          background: "#fff",
          boxShadow: "0 10px 40px rgba(0,0,0,0.2)",
        },
      }}
    >
      {/* HEADER */}
      <div className="bulk-modal-header">
        <h2 className="bulk-modal-title">
          {t("bulkUpload.BulkUpload")}
        </h2>
        <button
          onClick={() => dispatch(closeModal("bulkUploadInfoModal"))}
          className="bulk-modal-close"
        >
          ×
        </button>
      </div>

      {/* BODY */}
      <div className="bulk-modal-body">
        <div className="bulk-instruction-row">
          <FaInfoCircle color="#c67b05" size={22} />
          <p className="bulk-instruction-text">
            {t("bulkUpload.Instructions")}
            <a
              href="/bulk-fileUpload-guidance.pdf"
              target="_blank"
              rel="noopener noreferrer"
              className="bulk-guideline-link"
            >
              {t("bulkUpload.GuideLine")}
            </a>
            <span> {t("bulkUpload.InstructionCont")} </span>
            <li>
              {t("bulkUpload.Note")}{" "}
              <b>{t("bulkUpload.Record")}.</b>
            </li>
            {t("bulkUpload.OnlyFilesAllowed")}
            <b>.xlsx, .xls, </b>
            {t("bulkUpload.And")} <b>.csv</b>{" "}
            {t("bulkUpload.Only")}
          </p>
        </div>

        <div className="bulk-upload-actions">
          <button
            onClick={() => {
              handleBulkUploadButtonClick();
              fileInputRef.current?.click()
            }}
            className="bulk-upload-btn"
          >
            <FaUpload size={18} />
            {t("bulkUpload.ChooseFile")}
          </button>

          <input
            type="file"
            ref={fileInputRef}
            onChange={(e) => {
              onFileUpload(e);
              dispatch(closeModal("bulkUploadInfoModal"));
            }}
            className="hidden-file-input"
            accept=".xlsx,.xls,.csv"
          />
        </div>
      </div>
    </Modal>
  );
}
